// Extract the invite token (the path segment after `/invite/`) from the full
// link, robustly: parse the URL, find the `invite` segment and take the next
// one (so trailing segments like `/invite/<tok>/confirm` still yield `<tok>`).
// Falls back to a string split for non-absolute links. Kept out of the modal
// component so `react-refresh/only-export-components` stays happy.
export function extractInviteToken(inviteLink: string): string {
  try {
    const segments = new URL(inviteLink).pathname.split('/').filter(Boolean);
    const i = segments.indexOf('invite');
    return (i >= 0 ? segments[i + 1] : segments.at(-1)) ?? '';
  } catch {
    return inviteLink.split('/invite/')[1]?.split('/')[0] ?? '';
  }
}
